import { styled } from "@mui/material/styles";

const StyledChatComponent = styled('div')<{ isMobile?: boolean }>`
  min-height: ${props => props.isMobile ? 'none' : 'calc(100vh - 400px)'};
  height: ${props => props.isMobile ? 'var(--app-height)' : '100%'};
  transition: height 0.3s ease;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  overflow: auto;
  


  .chat-wrapper {
    
    &__header {
      padding: 24px;
      border-bottom: 1px solid ${props => props.theme.customTheme.colors.secondary};
    }

    &__main {
      position: relative;
      padding: 24px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;

      // NOTE scroll hosil qilish uchun
      overflow-y: auto;
      /* scroll-behavior: smooth; */
    }

    &__offer {
      position: sticky;
      top: 0;
      z-index: 2;
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
    }
    
    &__input {
      padding: 14px 24px;
      background-color: ${props => props.theme.customTheme.colors.whiteSmoke2};
    }
  }

  @media (max-width: 767.98px) {

    .chat-wrapper {
      &__header {
        padding: 8px 15px;
      }

      &__main {
        padding: 8px 15px;
      }

      &__offer {}

      &__input {
        padding: 8px 15px;
      }

    }
  }
`;

export {
  StyledChatComponent,
};

